import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectPhone } from "../../store/map";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import { AppLinearProgressBar } from "../../components";
import { sendAnalyticsEvents } from "../../analytics/common";
import { EVENTS } from "../../analytics/events";
import { selectEventsData } from "../../store/events";
import ReviewSlider from "../plans/components/ReviewsSlider";

export const LookingText = styled.div`
  margin-top: 24px;
  text-align: center;
  color: ${(props) => props.theme.colors.colorText};
	font-size: ${(props) => props.theme.fontSizes.font24};
	font-weight: ${(props) => props.theme.fontWeights.medium};
	line-height: ${(props) => props.theme.lineHeights.lineHeight24};
  letter-spacing: 0.5px;
`

export const PhoneText = styled.h1`
  margin-top: 8px;
  text-align: center;
  color: ${(props) => props.theme.colors.colorPrimary};
  font-size: ${(props) => props.theme.fontSizes.font32};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  letter-spacing: 0.045px;
`

const SearchingContainer = styled.div`
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity 0.5s ease;
`; 

const SearchingText = styled.p`
  margin-top: 8px;
  text-align: center;
  color: ${(props) => props.theme.colors.colorDisclaimerText};
  font-size: ${(props) => props.theme.fontSizes.font14};
  font-weight: ${(props) => props.theme.fontWeights.extraLight};
  line-height: ${(props) => props.theme.lineHeights.lineHeight20};
  letter-spacing: 0.02px;
`

const LineSeparator = styled.div`
  height: 1px;
  width: 100%;
  max-width: 330px;
  background-color: ${(props) => props.theme.colors.colorSeparator};
  margin: 30px 0 24px;
`

const PeopleText = styled.h3`
  text-align: center;
  color: ${(props) => props.theme.colors.colorPrimary};
  font-size: ${(props) => props.theme.fontSizes.font24};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  letter-spacing: -0.12px;
`

const ChoosenText = styled.p`
  margin-top: 8px;
  text-align: center;
  color: ${(props) => props.theme.colors.colorText};
  font-size: ${(props) => props.theme.fontSizes.font16};
  font-weight: ${(props) => props.theme.fontWeights.medium};
`

const LookingLocation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const phoneValue = useSelector(selectPhone);
  const [progress, setProgress] = useState(0);
  const [initEventSent, setInitEventStatus] = useState(false);
  const eventsData = useSelector(selectEventsData);
  const reviewsContent = useMemo(() => {
    return [
      {
				id: 1,
        reviewer: "Kevin Peters",
        text: t("review_1"),
      },
      {
				id: 2,
        reviewer: "John Lee",
        text: t("review_2"),
      },
      {
				id: 3,
        reviewer: "Megan Smith",
        text: t("review_3"),
      },
    ];
  }, [t]);
  useEffect(() => {
    if (initEventSent) return;
    sendAnalyticsEvents(EVENTS.onboardingLookingforShown, eventsData);
    setInitEventStatus(true)
  }, [eventsData, initEventSent]);

  useEffect(() => {
    if (progress === 100) {
      navigate('/approximate-location')
    }
  }, [progress, navigate]);

  useEffect(() => {
    if (phoneValue) {
      const timer = setInterval(() => {
        setProgress(prevProgress => {
          if (prevProgress >= 100) {
            clearInterval(timer);
            return 100;
          }
          return prevProgress + 10;
        });
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [phoneValue]);

  return (
    <>
      <LookingText>{t('looking_for')}</LookingText>
      <PhoneText>{formatPhoneNumberIntl(phoneValue)}</PhoneText>
      <SearchingText>{t("identifying_network")}</SearchingText>
      <SearchingContainer show={progress >= 40}>
        {progress >= 40 && <SearchingText>{t("searching_cellular")}</SearchingText>}
      </SearchingContainer>
      <AppLinearProgressBar />
      <LineSeparator />
      <PeopleText>{t('six_bln_people')}</PeopleText>
      <ChoosenText>{t('have_chosen')}</ChoosenText>
      <ReviewSlider slideData={reviewsContent}/>
    </>
  )
}

export default LookingLocation